import {Controller} from "stimulus";
import QrScanner from "qr-scanner";

export default class extends Controller {
  static targets = ["newWalletFields", "form"]
  
  connect() {
    this.initQr(document.querySelector("#videoQr"), $("#customer_wallet_address"), $("#qrStart"), $("#qrStop"));
  }
  
  invalidWalletInput() {
    const web3 = new window.Web3(window.Web3.givenProvider);
    const wallet_alert = document.querySelector(".customer-wallet-alert");
    const field_wallet_address = document.getElementById("customer_wallet_address");
    
    if (field_wallet_address && web3.utils.isAddress(field_wallet_address.value)){
      field_wallet_address.classList.remove("is-invalid");
      wallet_alert.classList.add("d-none");
    } else {
      field_wallet_address.classList.add("is-invalid");
      wallet_alert.classList.remove("d-none");
    }
  }
  
  checkSubmit(event) {
    event.preventDefault();
    this.invalidWalletInput();
    if (document.querySelector(".customer-wallet-alert").classList.contains("d-none")) {
      document.getElementById("form_customer_wallet_address").submit();
    }
  }
  
  initQr = (video, walletInput, startBtn, stopBtn) => {
    const qrScanner = new QrScanner(
      video,
      (result) => {
        walletInput.val(result.data);
        qrScanner.stop();
        video.style.height = "0px";
      },
      {
        highlightScanRegion: true
      }
    );
    
    startBtn.on("click", () => {
      video.style.height = "auto";
      qrScanner.start();
    });
    
    stopBtn.on("click", () => {
      video.style.height = "0px";
      qrScanner.stop();
    });
  };
}
